import * as React from "react";
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { MdMenu as HamburgerIcon } from "react-icons/md";

import { useMe } from "./api";
import { login, logout } from "./auth";
import { SITE_NAME } from "./cfg";
import { page_title } from "./global_state";
import { useAtom } from "jotai";

const Header = (): React.ReactNode => {
  const { data: me, isLoading: me_loading } = useMe();

  const page_title_val = useAtom(page_title)[0];

  const navigate = useNavigate();

  const log_in_out = () => {
    if (me) {
      logout();
    } else {
      login();
    }
  };
  const menu = [{ txt: "GoRules", link: "/erp/gorules" }];

  return (
    <Box w="full">
      <Container maxW="full">
        <Flex
          w="full"
          direction={{ base: "column", lg: "row" }}
          mt="3"
          alignItems="center"
          justifyContent="center"
        >
          <Box mb="4" flexGrow="1">
            <Link to="/" style={{ textDecoration: "none" }}>
              <Heading as="h1">{page_title_val || SITE_NAME}</Heading>
            </Link>
          </Box>
          <Menu>
            <MenuButton
              fontSize="3xl"
              as={Button}
              background="#00000000"
              ml="8"
            >
              <HamburgerIcon />
            </MenuButton>
            <MenuList>
              {menu.map(({ txt, link }) => (
                <MenuItem key={txt} onClick={() => navigate(link)}>
                  {txt}
                </MenuItem>
              ))}
              <MenuDivider />
              {me && (
                <MenuItem _hover={{ background: "initial" }}>
                  {me?.given_name}
                </MenuItem>
              )}
              {!me_loading && (
                <MenuItem onClick={log_in_out}>
                  {me ? "Sign-Out" : "Sign-In"}
                </MenuItem>
              )}
            </MenuList>
          </Menu>
        </Flex>
      </Container>
    </Box>
  );
};

export default Header;
